import { openPrintWindow, printTableElement, tableHtmlFromRows } from '../../../utils/exportUtils';

export const BG_EXPORT_EXCLUDE_CLASS = 'bg-export-exclude';

export const cloneTableForExport = (element) => {
  if (!element) return null;
  const clone = element.cloneNode(true);
  clone.querySelectorAll(`.${BG_EXPORT_EXCLUDE_CLASS}`).forEach((el) => el.remove());
  return clone;
};

export const exportBgTablePdf = ({ title, subtitle = '', element }) => {
  const clone = cloneTableForExport(element);
  if (!clone) return;
  const wrapper = document.createElement('div');
  wrapper.appendChild(clone);
  printTableElement({ title, subtitle, element: wrapper });
};

export const tableElementToCsv = (element) => {
  const clone = cloneTableForExport(element);
  if (!clone) return '';
  const table = clone.tagName === 'TABLE' ? clone : clone.querySelector('table');
  if (!table) return '';
  const lines = [];
  table.querySelectorAll('tr').forEach((tr) => {
    const cells = [...tr.querySelectorAll('th, td')].map((cell) => {
      const text = (cell.innerText || '').replace(/\s+/g, ' ').trim().replace(/"/g, '""');
      return `"${text}"`;
    });
    if (cells.length) lines.push(cells.join(','));
  });
  return lines.join('\n');
};

export const downloadCsvContent = (csv, filename = 'bg-export.csv') => {
  if (!csv) return;
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};

export const downloadBgTableCsv = ({ element, filename = 'bg-export.csv' }) => {
  downloadCsvContent(tableElementToCsv(element), filename);
};

export const exportDataRowsCsv = ({ headers, rows, filename = 'bg-export.csv' }) => {
  const head = headers.map((h) => `"${String(h).replace(/"/g, '""')}"`).join(',');
  const body = rows.map((row) => row.map((c) => `"${String(c ?? '').replace(/"/g, '""')}"`).join(',')).join('\n');
  downloadCsvContent(`${head}\n${body}`, filename);
};

export const exportDataRowsPdf = ({
  title,
  subtitle = '',
  headers,
  rows,
  amountColumnIndices = null,
  emptyMessage = 'No records found.',
}) => {
  openPrintWindow({
    title,
    subtitle,
    bodyHtml: tableHtmlFromRows({ headers, rows, amountColumnIndices, emptyMessage }),
  });
};

export const buildBgExportSubtitle = (parts = []) => parts.filter(Boolean).join(' | ');
